// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --backgroundGrey: #aaaaaa;
  --spacingHeight: 30px;
  --button: #333333;
  --buttonBackground: #ffffff;
  --buttonDisabledBackground: #c8c8c8;
  --disabledBackground: #c8c8c8;
  --buttonPressed: #ffffff;
  --buttonPressedBackground: #606060;
  --buttonHoverBackground: #afafaf;
}

#ge-propertyTab {
  user-select: none;
  color: black;
  background: #e2e2e2;
}
#ge-propertyTab * {
  font-family: "acumin-pro-condensed", sans-serif;
  font-size: 12px;
}
#ge-propertyTab #header {
  height: 32px;
  font-size: 16px;
  color: white;
  background: white;
  grid-row: 1;
  text-align: center;
  display: grid;
  grid-template-columns: 30px 1fr;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#ge-propertyTab #header #logo {
  position: relative;
  grid-column: 1;
  width: 32px;
  height: 32px;
  left: 0;
  display: flex;
  align-self: center;
  justify-self: center;
  filter: invert(1);
}
#ge-propertyTab #header #title {
  background: white;
  color: black;
  grid-column: 2;
  display: grid;
  align-items: center;
  text-align: center;
}
#ge-propertyTab .range {
  -webkit-appearance: none;
  width: 100%;
  height: 2px;
  background: #bcbcbc;
  border-radius: 5px;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  padding: 0;
}
#ge-propertyTab .range:hover {
  opacity: 1;
}
#ge-propertyTab .range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #e2e2e2;
  border: solid;
  border-width: thin;
  cursor: pointer;
}
#ge-propertyTab .range::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgb(0, 0, 0);
  cursor: pointer;
}
#ge-propertyTab input[type=color] {
  -webkit-appearance: none;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 0;
  width: 30px;
  height: 20px;
}
#ge-propertyTab input[type=color]::-webkit-color-swatch-wrapper {
  padding: 0;
}
#ge-propertyTab input[type=color]::-webkit-color-swatch {
  border: none;
}
#ge-propertyTab hr {
  border: 1px solid #d0cece;
}
#ge-propertyTab .icon {
  width: 30px;
  height: 30px;
}
#ge-propertyTab .unit {
  width: 26px;
  height: 26px;
  color: var(--button);
  background-color: var(--buttonBackground);
  border: none;
  margin-top: 2px;
  cursor: pointer;
  margin-left: 2px;
  font-family: "atten-round-new", sans-serif;
  font-weight: 500;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
}
#ge-propertyTab .unit:disabled {
  background-color: var(--buttonDisabledBackground);
  cursor: not-allowed;
}
#ge-propertyTab .unit:not(:disabled):hover {
  background-color: var(--buttonHoverBackground);
}
#ge-propertyTab .unit:not(:disabled):active {
  color: var(--buttonPressed);
  background-color: var(--buttonPressedBackground);
}
#ge-propertyTab input,
#ge-propertyTab select {
  outline-style: solid;
  outline-width: 0px;
  outline-color: transparent;
  outline-offset: -1px;
  outline-width: 1px;
  transition: outline-color 0.2s;
  border: transparent;
  padding-left: 5px;
}
#ge-propertyTab input:focus,
#ge-propertyTab select:focus {
  outline-width: 1px;
  outline-color: black;
}
#ge-propertyTab .hasArrows input::-webkit-outer-spin-button,
#ge-propertyTab .hasArrows input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
#ge-propertyTab .hasArrows input[type=number] {
  -moz-appearance: textfield;
}
#ge-propertyTab .sliderLine {
  height: var(--spacingHeight);
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: auto 1fr 20px 1fr;
  flex-grow: 1;
}
#ge-propertyTab .sliderLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
  min-width: 15px;
  font-weight: 600;
}
#ge-propertyTab .sliderLine .img {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .sliderLine .slider {
  grid-column: 4;
  grid-row: 1;
  margin-right: 5px;
  display: flex;
  align-items: center;
  padding-left: 5px;
}
#ge-propertyTab .sliderLine .floatLine {
  grid-column: 2;
  padding-left: 0px;
  grid-template-columns: 1fr auto;
}
#ge-propertyTab .sliderLine .floatLine .label {
  grid-column: 1;
  display: none;
  align-items: center;
  font-weight: 600;
}
#ge-propertyTab .sliderLine .floatLine .short {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .sliderLine .floatLine .short input {
  width: 100%;
  background-color: white;
  height: 24px;
}
#ge-propertyTab .sliderLine .floatLine .short input::-webkit-outer-spin-button,
#ge-propertyTab .sliderLine .floatLine .short input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
#ge-propertyTab .sliderLine .floatLine .short input[type=number] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
#ge-propertyTab .ge-divider {
  padding-right: 18px;
  padding-left: 5px;
  display: grid;
  grid-template-columns: auto 1fr;
  padding-top: 1px;
  padding-bottom: 1px;
}
#ge-propertyTab .ge-divider.double {
  display: grid;
  grid-template-columns: auto 1fr 5px 1fr;
}
#ge-propertyTab .ge-divider.double > .textInputLine:first-of-type,
#ge-propertyTab .ge-divider.double > .floatLine:first-of-type {
  grid-column: 2;
}
#ge-propertyTab .ge-divider.double > .textInputLine:nth-of-type(2),
#ge-propertyTab .ge-divider.double > .floatLine:nth-of-type(2) {
  grid-column: 4;
}
#ge-propertyTab .ge-divider.quad {
  display: grid;
  grid-template-columns: 1fr 5px 1fr 5px 1fr 5px 1fr;
}
#ge-propertyTab .ge-divider.quad > .textInputLine:first-of-type,
#ge-propertyTab .ge-divider.quad > .floatLine:first-of-type {
  grid-column: 1;
}
#ge-propertyTab .ge-divider.quad > .textInputLine:nth-of-type(2),
#ge-propertyTab .ge-divider.quad > .floatLine:nth-of-type(2) {
  grid-column: 3;
}
#ge-propertyTab .ge-divider.quad > .textInputLine:nth-of-type(3),
#ge-propertyTab .ge-divider.quad > .floatLine:nth-of-type(3) {
  grid-column: 5;
}
#ge-propertyTab .ge-divider.quad > .textInputLine:nth-of-type(4),
#ge-propertyTab .ge-divider.quad > .floatLine:nth-of-type(4) {
  grid-column: 7;
}
#ge-propertyTab .ge-grid-divider {
  display: grid;
  grid-template-columns: 150px 1fr auto;
}
#ge-propertyTab .ge-grid-divider .textLine {
  grid-column: auto;
}
#ge-propertyTab .ge-grid-button-divider {
  display: grid;
  grid-template-columns: 60px 60px 60px 60px;
}
#ge-propertyTab .ge-grid-remove {
  display: grid;
  background-color: #c2c2c2;
  margin-bottom: 5px;
  filter: invert(1);
}
#ge-propertyTab .ge-grid-edit {
  display: grid;
  background-color: #878787;
  margin-bottom: 5px;
  filter: invert(1);
}
#ge-propertyTab .ge-grid {
  display: grid;
  margin-bottom: 5px;
}
#ge-propertyTab .ge-divider.double .textInputLine {
  grid-template-columns: auto auto 1fr auto;
}
#ge-propertyTab .textInputLine,
#ge-propertyTab .floatLine {
  user-select: none;
  padding-bottom: 0px;
  padding-top: 0px;
  height: var(--spacingHeight);
  display: grid;
  grid-template-columns: auto auto 1fr;
  flex-grow: 1;
}
#ge-propertyTab .textInputLine .label,
#ge-propertyTab .floatLine .label {
  grid-column: 2;
  display: flex;
  align-items: center;
  min-width: 15px;
  font-weight: 600;
}
#ge-propertyTab .textInputLine .disabled,
#ge-propertyTab .floatLine .disabled {
  color: var(--backgroundGrey);
  background-color: var(--disabledBackground);
}
#ge-propertyTab .textInputLine img,
#ge-propertyTab .floatLine img {
  width: 30px;
}
#ge-propertyTab .textInputLine .img,
#ge-propertyTab .floatLine .img {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .textInputLine .value,
#ge-propertyTab .floatLine .value {
  display: flex;
  align-items: center;
  grid-column: 3;
  background: transparent;
  height: 26px;
  position: relative;
  background-color: white;
  margin-top: 2px;
  overflow-y: hidden;
}
#ge-propertyTab .textInputLine .value input,
#ge-propertyTab .floatLine .value input {
  width: 100%;
  height: 24px;
  color: #333333;
}
#ge-propertyTab .textInputLine .value input.hasArrows,
#ge-propertyTab .floatLine .value input.hasArrows {
  padding-right: 15px;
}
#ge-propertyTab .textInputLine .value .arrows,
#ge-propertyTab .floatLine .value .arrows {
  display: none;
  position: absolute;
  right: 0;
  flex-direction: column;
  cursor: grab;
}
#ge-propertyTab .textInputLine .value .arrows .downArrowIcon,
#ge-propertyTab .textInputLine .value .arrows .upArrowIcon,
#ge-propertyTab .floatLine .value .arrows .downArrowIcon,
#ge-propertyTab .floatLine .value .arrows .upArrowIcon {
  width: 13px;
  height: 13px;
}
#ge-propertyTab .textInputLine .value:hover .arrows, #ge-propertyTab .textInputLine .value:focus .arrows, #ge-propertyTab .textInputLine .value.dragging .arrows,
#ge-propertyTab .floatLine .value:hover .arrows,
#ge-propertyTab .floatLine .value:focus .arrows,
#ge-propertyTab .floatLine .value.dragging .arrows {
  display: flex;
}
#ge-propertyTab .textInputLine .value .arrows:hover,
#ge-propertyTab .floatLine .value .arrows:hover {
  background-color: var(--buttonHoverBackground);
}
#ge-propertyTab .textInputLine .value.dragging .arrows,
#ge-propertyTab .floatLine .value.dragging .arrows {
  background-color: var(--buttonPressedBackground);
}
#ge-propertyTab .textInputLine .value.dragging .arrows .downArrowIcon,
#ge-propertyTab .textInputLine .value.dragging .arrows .upArrowIcon,
#ge-propertyTab .floatLine .value.dragging .arrows .downArrowIcon,
#ge-propertyTab .floatLine .value.dragging .arrows .upArrowIcon {
  filter: brightness(10);
}
#ge-propertyTab .textInputLine.withUnits {
  grid-template-columns: auto auto 1fr auto;
}
#ge-propertyTab .textInputArea {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 120px;
}
#ge-propertyTab .textInputArea .disabled {
  color: var(--backgroundGrey);
  background-color: var(--disabledBackground);
}
#ge-propertyTab .textInputArea .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .textInputArea .value {
  display: flex;
  align-items: center;
  grid-column: 2;
}
#ge-propertyTab .textInputArea .value textarea {
  width: calc(150% - 5px);
  margin-left: -50%;
  height: 40px;
}
#ge-propertyTab .paneContainer {
  margin-top: 3px;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 100%;
}
#ge-propertyTab .paneContainer .paneList {
  border-left: 3px solid transparent;
}
#ge-propertyTab .paneContainer:hover .paneList {
  border-left: 3px solid rgba(51, 122, 183, 0.8);
}
#ge-propertyTab .paneContainer:hover .paneContainer-content .header .title {
  border-left: 3px solid rgb(51, 122, 183);
}
#ge-propertyTab .paneContainer .paneContainer-highlight-border {
  grid-row: 1;
  grid-column: 1;
  opacity: 1;
  border: 3px solid red;
  transition: opacity 250ms;
  pointer-events: none;
}
#ge-propertyTab .paneContainer .paneContainer-highlight-border.transparent {
  opacity: 0;
}
#ge-propertyTab .paneContainer .paneContainer-content {
  grid-row: 1;
  grid-column: 1;
}
#ge-propertyTab .paneContainer .paneContainer-content .header {
  display: grid;
  grid-template-columns: 1fr auto;
  background: #cccccc;
  height: var(--spacingHeight);
  padding-bottom: 0px;
  padding-top: 0px;
  padding-right: 5px;
  cursor: pointer;
}
#ge-propertyTab .paneContainer .paneContainer-content .header .title {
  border-left: 3px solid transparent;
  padding-left: 5px;
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .paneContainer .paneContainer-content .header .collapse {
  grid-column: 2;
  display: flex;
  align-items: center;
  justify-items: center;
  transform-origin: center;
}
#ge-propertyTab .paneContainer .paneContainer-content .header .collapse.closed {
  transform: rotate(180deg);
}
#ge-propertyTab .paneContainer .paneContainer-content .paneList > div:not(:last-child) {
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);
}
#ge-propertyTab .paneContainer .paneContainer-content .fragment > div:not(:last-child) {
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);
}
#ge-propertyTab .color-picker {
  height: 26px;
  width: 26px;
}
#ge-propertyTab .color-picker .color-rect-background {
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px black solid;
  cursor: pointer;
  background: repeating-conic-gradient(#e2e2e2 0% 25%, white 0% 50%) 50%/100% 100%;
}
#ge-propertyTab .color-picker .color-rect-background .color-rect {
  height: 100%;
}
#ge-propertyTab .color-picker .color-picker-cover {
  z-index: 2;
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
#ge-propertyTab .color-picker .color-picker-float {
  position: absolute;
  outline: 1px solid black;
}
#ge-propertyTab .color-picker .color-picker-container {
  background-color: #e2e2e2;
}
#ge-propertyTab .gradient-step {
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 20px 30px 40px auto 20px 30px;
  padding-top: 5px;
  padding-left: 5px;
  padding-bottom: 5px;
}
#ge-propertyTab .gradient-step .step {
  grid-row: 1;
  grid-column: 1;
}
#ge-propertyTab .gradient-step .color {
  grid-row: 1;
  grid-column: 2;
  cursor: pointer;
}
#ge-propertyTab .gradient-step .step-value {
  margin-left: 5px;
  grid-row: 1;
  grid-column: 3;
  text-align: right;
  margin-right: 5px;
}
#ge-propertyTab .gradient-step .step-slider {
  grid-row: 1;
  grid-column: 4;
  display: grid;
  justify-content: stretch;
  align-content: center;
  margin-right: -5px;
  padding-left: 12px;
}
#ge-propertyTab .gradient-step .step-slider input {
  width: 90%;
}
#ge-propertyTab .gradient-step .gradient-copy {
  grid-row: 1;
  grid-column: 5;
  display: grid;
  align-content: center;
  justify-content: center;
}
#ge-propertyTab .gradient-step .gradient-copy .img {
  height: 20px;
  width: 20px;
}
#ge-propertyTab .gradient-step .gradient-copy .img:hover {
  cursor: pointer;
}
#ge-propertyTab .gradient-step .gradient-delete {
  grid-row: 1;
  grid-column: 6;
  display: grid;
  align-content: center;
  justify-content: center;
}
#ge-propertyTab .gradient-step .gradient-delete .img {
  height: 20px;
  width: 20px;
}
#ge-propertyTab .gradient-step .gradient-delete .img:hover {
  cursor: pointer;
}
#ge-propertyTab .alignment-bar {
  display: flex;
  justify-content: center;
  padding-right: 5px;
}
#ge-propertyTab .command-button {
  cursor: pointer;
  width: 30px;
}
#ge-propertyTab .command-button .command-label {
  display: none;
}
#ge-propertyTab .command-button .command-button-icon {
  height: 100%;
  width: 100%;
  display: grid;
  color: white;
  align-content: center;
  justify-content: center;
}
#ge-propertyTab .command-button:hover {
  background-color: white;
}
#ge-propertyTab .command-button .active {
  transform-origin: center;
  background-color: white;
}
#ge-propertyTab .command-button img.active {
  background-color: white;
}
#ge-propertyTab .command-button.disabled {
  background-color: var(--buttonDisabledBackground);
  pointer-events: none;
}
#ge-propertyTab .command-button-alt {
  cursor: pointer;
  width: 40px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
}
#ge-propertyTab .command-button-alt .command-label {
  display: none;
}
#ge-propertyTab .command-button-alt .command-button-icon {
  height: 100%;
  width: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
}
#ge-propertyTab .command-button-alt:hover {
  background-color: #c2c2c2;
  filter: invert(1);
}
#ge-propertyTab .command-button-alt-disabled {
  cursor: pointer;
  pointer-events: none;
  width: 40px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
}
#ge-propertyTab .command-button-alt-disabled .command-label {
  display: none;
}
#ge-propertyTab .command-button-alt-disabled .command-button-icon {
  height: 100%;
  width: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
}
#ge-propertyTab .command-button-alt-disabled img {
  filter: invert(1);
}
#ge-propertyTab .command-button-alt-active {
  cursor: pointer;
  pointer-events: none;
  width: 40px;
  margin-left: 5px;
  margin-right: 5px;
  background-color: #c2c2c2;
  filter: invert(1);
}
#ge-propertyTab .command-button-alt-active .command-label {
  display: none;
}
#ge-propertyTab .command-button-alt-active .command-button-icon {
  height: 100%;
  width: 100%;
  display: grid;
  align-content: center;
  justify-content: center;
}
#ge-propertyTab .floatLine {
  user-select: none;
  height: var(--spacingHeight);
  padding-bottom: 0px;
  padding-top: 0px;
  display: grid;
  grid-template-columns: auto auto 2fr auto;
  flex-grow: 1;
}
#ge-propertyTab .floatLine .label {
  grid-column: 2;
  display: flex;
  align-items: center;
  min-width: 15px;
  font-weight: 600;
}
#ge-propertyTab .floatLine img {
  width: 30px;
}
#ge-propertyTab .floatLine .img {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .floatLine .value {
  display: flex;
  align-items: center;
  grid-column: 3;
  background: transparent;
  height: 26px;
}
#ge-propertyTab .floatLine .value input {
  width: 100%;
  background-color: white;
  height: 24px;
}
#ge-propertyTab .floatLine .short {
  grid-column: 2;
  display: flex;
  align-items: center;
}
#ge-propertyTab .floatLine .short input {
  width: 100%;
}
#ge-propertyTab .floatLine .short input::-webkit-outer-spin-button,
#ge-propertyTab .floatLine .short input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
#ge-propertyTab .floatLine .short input[type=number] {
  -moz-appearance: textfield;
}
#ge-propertyTab .vector3Line {
  padding-bottom: 0px;
  padding-top: 0px;
  display: grid;
}
#ge-propertyTab .vector3Line .firstLine {
  display: grid;
  grid-template-columns: 1fr auto 20px;
  height: var(--spacingHeight);
}
#ge-propertyTab .vector3Line .firstLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .vector3Line .firstLine .vector {
  grid-column: 2;
  display: flex;
  align-items: center;
  text-align: right;
  opacity: 0.8;
}
#ge-propertyTab .vector3Line .firstLine .expand {
  grid-column: 3;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#ge-propertyTab .vector3Line .secondLine {
  display: grid;
  padding-right: 5px;
  border-left: 1px solid rgb(51, 122, 183);
}
#ge-propertyTab .vector3Line .secondLine .no-right-margin {
  margin-right: 0;
}
#ge-propertyTab .vector3Line .secondLine .numeric {
  display: grid;
  grid-template-columns: 1fr auto;
}
#ge-propertyTab .vector3Line .secondLine .numeric-label {
  text-align: right;
  grid-column: 1;
  display: flex;
  align-items: center;
  justify-self: right;
  margin-right: 10px;
}
#ge-propertyTab .vector3Line .secondLine .numeric-value {
  width: 120px;
  grid-column: 2;
  display: flex;
  align-items: center;
  border: 1px solid rgb(51, 122, 183);
}
#ge-propertyTab .buttonLine {
  height: var(--spacingHeight);
  padding-bottom: 0px;
  padding-top: 0px;
  display: grid;
  align-items: center;
  justify-items: stretch;
  padding-bottom: 5px;
}
#ge-propertyTab .buttonLine input[type=file] {
  display: none;
}
#ge-propertyTab .buttonLine .file-upload {
  background: var(--backgroundGrey);
  border: 1px solid #424242;
  margin: 5px 10px;
  color: white;
  padding: 4px 5px;
  opacity: 0.9;
  cursor: pointer;
  text-align: center;
  border-radius: 4px;
}
#ge-propertyTab .buttonLine .file-upload:hover {
  opacity: 1;
}
#ge-propertyTab .buttonLine .file-upload:active {
  transform: scale(0.98);
  transform-origin: 0.5 0.5;
}
#ge-propertyTab .buttonLine button {
  background: var(--backgroundGrey);
  border: 1px solid #424242;
  margin: 5px 10px 5px 10px;
  color: white;
  padding: 4px 5px;
  opacity: 0.9;
  border-radius: 4px;
}
#ge-propertyTab .buttonLine button:hover {
  opacity: 1;
}
#ge-propertyTab .buttonLine button:active {
  background: #282828;
}
#ge-propertyTab .buttonLine button:focus {
  border: 1px solid #424242;
  outline: 0px;
}
#ge-propertyTab .numeric {
  padding-bottom: 0px;
  padding-top: 0px;
  height: var(--spacingHeight);
  display: grid;
  grid-template-columns: 1fr 120px auto;
}
#ge-propertyTab .numeric .numeric-label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .numeric .number {
  display: flex;
  align-items: center;
  grid-column: 2;
  height: 10px;
}
#ge-propertyTab .numeric .number .input {
  width: calc(100% - 5px);
  height: 10px;
}
#ge-propertyTab .checkBoxLine {
  padding-bottom: 0px;
  padding-top: 0px;
  height: var(--spacingHeight);
  display: grid;
  grid-template-columns: auto 1fr auto;
  flex-grow: 1;
}
#ge-propertyTab .checkBoxLine .label {
  grid-column: 2;
  display: flex;
  align-items: center;
  min-width: 100px;
  margin-left: 15px;
  height: var(--spacingHeight);
  font-weight: 600;
}
#ge-propertyTab .checkBoxLine img {
  width: 30px;
}
#ge-propertyTab .checkBoxLine .img {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .checkBoxLine .hidden {
  display: none;
}
#ge-propertyTab .listLine {
  padding-bottom: 0px;
  padding-top: 0px;
  height: var(--spacingHeight);
  display: grid;
  grid-template-columns: auto 1fr auto;
  flex-grow: 1;
}
#ge-propertyTab .listLine .label {
  grid-column: 2;
  display: none;
  align-items: center;
}
#ge-propertyTab .listLine img {
  width: 30px;
}
#ge-propertyTab .listLine .img {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .listLine .options {
  grid-column: 2;
  padding-left: 15px;
  display: flex;
  align-items: center;
}
#ge-propertyTab .listLine .options select {
  width: 100%;
  height: 25px;
  border: transparent;
}
#ge-propertyTab .listLine .options input {
  width: 100%;
  height: 24px;
  color: #333333;
}
#ge-propertyTab .color3Line {
  padding-left: 15px;
  padding-bottom: 0px;
  padding-top: 0px;
  display: grid;
  flex-grow: 1;
}
#ge-propertyTab .color3Line .firstLine {
  height: var(--spacingHeight);
  display: flex;
  align-items: center;
}
#ge-propertyTab .color3Line .firstLine .label {
  grid-column: 2;
  padding-left: 5px;
  display: none;
  align-items: center;
  min-width: 15px;
}
#ge-propertyTab .color3Line .firstLine .img {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .color3Line .firstLine img {
  width: 30px;
  height: 30px;
}
#ge-propertyTab .color3Line .firstLine .textInputLine {
  grid-column: 3;
  padding-left: 2px;
  flex-grow: 1;
}
#ge-propertyTab .color3Line .firstLine .color3 {
  display: flex;
  align-items: center;
}
#ge-propertyTab .color3Line .firstLine .color3 input {
  margin-right: 5px;
}
#ge-propertyTab .color3Line .firstLine .copy {
  grid-column: 4;
  display: none;
  align-items: center;
  justify-items: center;
  cursor: pointer;
  color: black;
}
#ge-propertyTab .color3Line .firstLine .copy img {
  height: 100%;
  width: 20px;
}
#ge-propertyTab .color3Line .firstLine .expand {
  grid-column: 4;
  display: none;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#ge-propertyTab .color3Line .firstLine .expand img {
  height: 100%;
  width: 20px;
}
#ge-propertyTab .color3Line .secondLine {
  display: grid;
  padding-right: 5px;
  border-left: 1px solid rgb(51, 122, 183);
}
#ge-propertyTab .color3Line .secondLine .numeric {
  display: grid;
  grid-template-columns: 1fr auto;
}
#ge-propertyTab .color3Line .secondLine .numeric-label {
  text-align: right;
  grid-column: 1;
  display: flex;
  align-items: center;
  justify-self: right;
  margin-right: 10px;
}
#ge-propertyTab .color3Line .secondLine .numeric-value {
  width: 120px;
  grid-column: 2;
  display: flex;
  align-items: center;
  border: 1px solid rgb(51, 122, 183);
}
#ge-propertyTab .textLine {
  padding-left: 5px;
  padding-bottom: 0px;
  padding-top: 0px;
  padding-right: 18px;
  height: auto;
  display: grid;
  grid-template-columns: auto auto 2fr 1fr;
}
#ge-propertyTab .textLine .label {
  grid-column: 2;
  padding-left: 5px;
  padding-top: 4px;
  display: flex;
  align-items: left;
  min-width: 15px;
  color: #a9a9a9;
  font-size: 10px;
  font-family: "acumin-pro-semi-condensed", sans-serif;
  font-weight: 600;
}
#ge-propertyTab .textLine img {
  width: 30px;
}
#ge-propertyTab .textLine .img {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#ge-propertyTab .textLine .link-value {
  grid-column: 2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: end;
  opacity: 0.8;
  margin: 5px;
  margin-top: 6px;
  max-width: 140px;
  text-decoration: underline;
  cursor: pointer;
}
#ge-propertyTab .textLine .value {
  display: none;
  grid-column: 3;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: end;
  opacity: 0.8;
  margin: 5px;
  margin-top: 6px;
  max-width: 200px;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
#ge-propertyTab .textLine .value.check {
  color: green;
}
#ge-propertyTab .textLine .value.uncheck {
  color: red;
}`, "",{"version":3,"sources":["webpack://./../../../tools/guiEditor/dist/components/propertyTab/propertyTab.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,gCAAA;AACJ;;AAEA;EACI,iBAAA;EAKA,YAAA;EACA,mBAAA;AAHJ;AAII;EACI,+CAAA;EACA,eAAA;AAFR;AAII;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,+BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAFR;AAIQ;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,iBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAHZ;AAOI;EACI,wBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;EACA,UAAA;AALR;AAQI;EACI,UAAA;AANR;AASI;EACI,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAPR;AAUI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;AARR;AAWI;EACI,wBAAA;EACA,0CAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AATR;AAWI;EACI,UAAA;AATR;AAWI;EACI,YAAA;AATR;AAYI;EACI,yBAAA;AAVR;AAaI;EACI,WAAA;EACA,YAAA;AAXR;AAcI;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yCAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAZR;AAeI;EACI,iDAAA;EACA,mBAAA;AAbR;AAgBI;EACI,8CAAA;AAdR;AAiBI;EACI,2BAAA;EACA,gDAAA;AAfR;AAkBI;;EAEI,oBAAA;EACA,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAhBR;AAkBQ;;EACI,kBAAA;EACA,oBAAA;AAfZ;AAmBI;;EAEI,wBAAA;EACA,SAAA;AAjBR;AAoBI;EACI,0BAAA;AAlBR;AAqBI;EACI,4BAAA;EACA,aAAA;EACA,wBAAA;EACA,wCAAA;EACA,YAAA;AAnBR;AAqBQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAnBZ;AAsBQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AApBZ;AAuBQ;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AArBZ;AAwBQ;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;AAtBZ;AAwBY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAtBhB;AAyBY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAvBhB;AAyBgB;EACI,WAAA;EACA,uBAAA;EACA,YAAA;AAvBpB;AA0BgB;;EAEI,wBAAA;EACA,SAAA;AAxBpB;AA2BgB;EACI,6BAAA;EACA,0BAAA;EACA,qBAAA;AAzBpB;AA+BI;EACI,mBAtOiB;EAuOjB,iBAAA;EACA,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AA7BR;AA+BI;EACI,aAAA;EACA,uCAAA;AA7BR;AAgCY;;EACI,cAAA;AA7BhB;AA+BY;;EACI,cAAA;AA5BhB;AAgCI;EACI,aAAA;EACA,kDAAA;AA9BR;AAiCY;;EACI,cAAA;AA9BhB;AAgCY;;EACI,cAAA;AA7BhB;AA+BY;;EACI,cAAA;AA5BhB;AA8BY;;EACI,cAAA;AA3BhB;AA+BI;EACI,aAAA;EACA,qCAAA;AA7BR;AA+BQ;EACI,iBAAA;AA7BZ;AAiCI;EACI,aAAA;EACA,0CAAA;AA/BR;AAkCI;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAhCR;AAmCI;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAjCR;AAoCI;EACI,aAAA;EACA,kBAAA;AAlCR;AAqCI;EACI,yCAAA;AAnCR;AAsCI;;EAEI,iBAAA;EACA,mBAvTkB;EAwTlB,gBAvTe;EAwTf,4BAAA;EACA,aAAA;EACA,oCAAA;EACA,YAAA;AApCR;AAqCQ;;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAlCZ;AAqCQ;;EACI,4BAAA;EACA,2CAAA;AAlCZ;AAqCQ;;EACI,WAAA;AAlCZ;AAqCQ;;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAlCZ;AAqCQ;;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAlCZ;AAmCY;;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAhChB;AAkCY;;EACI,mBAAA;AA/BhB;AAiCY;;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,YAAA;AA9BhB;AA+BgB;;;;EAEI,WAAA;EACA,YAAA;AA3BpB;AA8BY;;;;EAGI,aAAA;AA3BhB;AA6BY;;EACI,8CAAA;AA1BhB;AA4BY;;EACI,gDAAA;AAzBhB;AA0BgB;;;;EAEI,sBAAA;AAtBpB;AA4BI;EACI,yCAAA;AA1BR;AA6BI;EACI,YAAA;EACA,aAAA;EACA,gCAAA;AA3BR;AA6BQ;EACI,4BAAA;EACA,2CAAA;AA3BZ;AA8BQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA5BZ;AA+BQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AA7BZ;AA+BY;EACI,uBAAA;EACA,iBAAA;EACA,YAAA;AA7BhB;AAkCI;EACI,eAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;AAhCR;AAkCQ;EACI,kCAAA;AAhCZ;AAoCY;EACI,8CAAA;AAlChB;AAuCoB;EACI,wCAAA;AArCxB;AA2CQ;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;AAzCZ;AA2CY;EACI,UAAA;AAzChB;AA6CQ;EACI,WAAA;EACA,cAAA;AA3CZ;AA6CY;EACI,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAndU;EAodV,gBAndO;EAodP,kBAAA;EACA,eAAA;AA3ChB;AA6CgB;EACI,kCAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AA3CpB;AA8CgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;AA5CpB;AA8CoB;EACI,yBAAA;AA5CxB;AAiDY;EACI,mDAAA;AA/ChB;AAkDY;EACI,mDAAA;AAhDhB;AAqDI;EACI,YAAA;EACA,WAAA;AAnDR;AAqDQ;EACI,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,eAAA;EACA,gFAAA;AAnDZ;AAoDY;EACI,YAAA;AAlDhB;AAsDQ;EACI,UAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;AApDZ;AAuDQ;EACI,kBAAA;EACA,wBAAA;AArDZ;AAwDQ;EACI,yBAAA;AAtDZ;AA0DI;EACI,aAAA;EACA,wBAAA;EACA,oDAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAxDR;AA0DQ;EACI,WAAA;EACA,cAAA;AAxDZ;AA2DQ;EACI,WAAA;EACA,cAAA;EACA,eAAA;AAzDZ;AA4DQ;EACI,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AA1DZ;AA6DQ;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AA3DZ;AA6DY;EACI,UAAA;AA3DhB;AA+DQ;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA7DZ;AA+DY;EACI,YAAA;EACA,WAAA;AA7DhB;AA+DY;EACI,eAAA;AA7DhB;AAgEQ;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA9DZ;AA+DY;EACI,YAAA;EACA,WAAA;AA7DhB;AA+DY;EACI,eAAA;AA7DhB;AAkEI;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;AAhER;AAmEI;EACI,eAAA;EACA,WAAA;AAjER;AAmEQ;EACI,aAAA;AAjEZ;AAoEQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;AAlEZ;AAqEQ;EACI,uBAAA;AAnEZ;AAsEQ;EACI,wBAAA;EACA,uBAAA;AApEZ;AAwEY;EACI,uBAAA;AAtEhB;AA0EQ;EACI,iDAAA;EACA,oBAAA;AAxEZ;AA4EI;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EAKA,uBAAA;AA9ER;AA0EQ;EACI,aAAA;AAxEZ;AA4EQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA1EZ;AA4EQ;EACI,yBAAA;EACA,iBAAA;AA1EZ;AA8EI;EACI,eAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EAKA,uBAAA;AAhFR;AA4EQ;EACI,aAAA;AA1EZ;AA8EQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA5EZ;AA+EQ;EACI,iBAAA;AA7EZ;AAiFI;EACI,eAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EAKA,yBAAA;EACA,iBAAA;AAnFR;AA8EQ;EACI,aAAA;AA5EZ;AAiFQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA/EZ;AAmFI;EACI,iBAAA;EACA,4BAAA;EACA,mBAptBkB;EAqtBlB,gBAptBe;EAqtBf,aAAA;EACA,yCAAA;EACA,YAAA;AAjFR;AAmFQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAjFZ;AAoFQ;EACI,WAAA;AAlFZ;AAqFQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAnFZ;AAsFQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;AApFZ;AAqFY;EACI,WAAA;EACA,uBAAA;EACA,YAAA;AAnFhB;AAuFQ;EACI,cAAA;EAEA,aAAA;EACA,mBAAA;AAtFZ;AAwFY;EACI,WAAA;AAtFhB;AAyFY;;EAEI,wBAAA;EACA,SAAA;AAvFhB;AA0FY;EACI,0BAAA;AAxFhB;AA6FI;EACI,mBAhxBkB;EAixBlB,gBAhxBe;EAixBf,aAAA;AA3FR;AA4FQ;EACI,aAAA;EACA,oCAAA;EACA,4BAAA;AA1FZ;AA4FY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA1FhB;AA6FY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AA3FhB;AA8FY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AA5FhB;AAgGQ;EACI,aAAA;EACA,kBAAA;EACA,wCAAA;AA9FZ;AAgGY;EACI,eAAA;AA9FhB;AAiGY;EACI,aAAA;EACA,+BAAA;AA/FhB;AAkGY;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAhGhB;AAmGY;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAjGhB;AAsGI;EACI,4BAAA;EACA,mBAl1BkB;EAm1BlB,gBAl1Be;EAm1Bf,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AApGR;AAqGQ;EACI,aAAA;AAnGZ;AAsGQ;EACI,iCAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AApGZ;AAuGQ;EACI,UAAA;AArGZ;AAwGQ;EACI,sBAAA;EACA,yBAAA;AAtGZ;AAyGQ;EACI,iCAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAvGZ;AA0GQ;EACI,UAAA;AAxGZ;AA2GQ;EACI,mBAAA;AAzGZ;AA4GQ;EACI,yBAAA;EACA,YAAA;AA1GZ;AA8GI;EACI,mBA14BkB;EA24BlB,gBA14Be;EA24Bf,4BAAA;EACA,aAAA;EACA,qCAAA;AA5GR;AA8GQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA5GZ;AA+GQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AA7GZ;AA8GY;EACI,uBAAA;EACA,YAAA;AA5GhB;AAiHI;EACI,mBAn6BkB;EAo6BlB,gBAn6Be;EAo6Bf,4BAAA;EACA,aAAA;EACA,oCAAA;EACA,YAAA;AA/GR;AAiHQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AA/GZ;AAkHQ;EACI,WAAA;AAhHZ;AAmHQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAjHZ;AAoHQ;EACI,aAAA;AAlHZ;AAsHI;EACI,mBAp8BkB;EAq8BlB,gBAp8Be;EAq8Bf,4BAAA;EACA,aAAA;EACA,oCAAA;EACA,YAAA;AApHR;AAsHQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AApHZ;AAuHQ;EACI,WAAA;AArHZ;AAwHQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAtHZ;AAyHQ;EACI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAvHZ;AAyHY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAvHhB;AA0HY;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAxHhB;AA6HI;EACI,kBAAA;EACA,mBAj/BkB;EAk/BlB,gBAj/Be;EAk/Bf,aAAA;EACA,YAAA;AA3HR;AA6HQ;EACI,4BAAA;EACA,aAAA;EACA,mBAAA;AA3HZ;AA6HY;EACI,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA3HhB;AA8HY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA5HhB;AA+HY;EACI,WAAA;EACA,YAAA;AA7HhB;AAgIY;EACI,cAAA;EACA,iBAAA;EACA,YAAA;AA9HhB;AAiIY;EACI,aAAA;EACA,mBAAA;AA/HhB;AAiIgB;EACI,iBAAA;AA/HpB;AAmIY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AAjIhB;AAkIgB;EACI,YAAA;EACA,WAAA;AAhIpB;AAoIY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAlIhB;AAoIgB;EACI,YAAA;EACA,WAAA;AAlIpB;AAuIQ;EACI,aAAA;EACA,kBAAA;EACA,wCAAA;AArIZ;AAuIY;EACI,aAAA;EACA,+BAAA;AArIhB;AAwIY;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAtIhB;AAyIY;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAvIhB;AA4II;EACI,iBAvlCgB;EAwlChB,mBAvlCkB;EAwlClB,gBAvlCe;EAwlCf,mBAvlCiB;EAwlCjB,YAAA;EACA,aAAA;EACA,wCAAA;AA1IR;AA2IQ;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oDAAA;EACA,gBAAA;AAzIZ;AA4IQ;EACI,WAAA;AA1IZ;AA6IQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA3IZ;AA8IQ;EACI,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AA5IZ;AA+IQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AA7IZ;AA+IY;EACI,YAAA;AA7IhB;AAgJY;EACI,UAAA;AA9IhB","sourcesContent":[":root {\r\n    --backgroundGrey: #aaaaaa;\r\n    --spacingHeight: 30px;\r\n    --button: #333333;\r\n    --buttonBackground: #ffffff;\r\n    --buttonDisabledBackground: #c8c8c8;\r\n    --disabledBackground: #c8c8c8;\r\n    --buttonPressed: #ffffff;\r\n    --buttonPressedBackground: #606060;\r\n    --buttonHoverBackground: #afafaf;\r\n}\r\n\r\n#ge-propertyTab {\r\n    user-select: none;\r\n    $line-padding-left: 5px;\r\n    $line-padding-bottom: 0px;\r\n    $line-padding-top: 0px;\r\n    $line-padding-right: 18px;\r\n    color: black;\r\n    background: #e2e2e2;\r\n    * {\r\n        font-family: \"acumin-pro-condensed\", sans-serif;\r\n        font-size: 12px;\r\n    }\r\n    #header {\r\n        height: 32px;\r\n        font-size: 16px;\r\n        color: white;\r\n        background: white;\r\n        grid-row: 1;\r\n        text-align: center;\r\n        display: grid;\r\n        grid-template-columns: 30px 1fr;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n\r\n        #logo {\r\n            position: relative;\r\n            grid-column: 1;\r\n            width: 32px;\r\n            height: 32px;\r\n            left: 0;\r\n            display: flex;\r\n            align-self: center;\r\n            justify-self: center;\r\n            filter: invert(1);\r\n        }\r\n\r\n        #title {\r\n            background: white;\r\n            color: black;\r\n            grid-column: 2;\r\n            display: grid;\r\n            align-items: center;\r\n            text-align: center;\r\n        }\r\n    }\r\n\r\n    .range {\r\n        -webkit-appearance: none;\r\n        width: 100%;\r\n        height: 2px;\r\n        background: #bcbcbc;\r\n        border-radius: 5px;\r\n        outline: none;\r\n        opacity: 0.7;\r\n        -webkit-transition: 0.2s;\r\n        transition: opacity 0.2s;\r\n        padding: 0;\r\n    }\r\n\r\n    .range:hover {\r\n        opacity: 1;\r\n    }\r\n\r\n    .range::-webkit-slider-thumb {\r\n        -webkit-appearance: none;\r\n        appearance: none;\r\n        width: 14px;\r\n        height: 14px;\r\n        border-radius: 50%;\r\n        background: #e2e2e2;\r\n        border: solid;\r\n        border-width: thin;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .range::-moz-range-thumb {\r\n        width: 14px;\r\n        height: 14px;\r\n        border-radius: 50%;\r\n        background: rgb(0, 0, 0);\r\n        cursor: pointer;\r\n    }\r\n\r\n    input[type=\"color\"] {\r\n        -webkit-appearance: none;\r\n        border: 1px solid rgba(255, 255, 255, 0.5);\r\n        padding: 0;\r\n        width: 30px;\r\n        height: 20px;\r\n    }\r\n    input[type=\"color\"]::-webkit-color-swatch-wrapper {\r\n        padding: 0;\r\n    }\r\n    input[type=\"color\"]::-webkit-color-swatch {\r\n        border: none;\r\n    }\r\n\r\n    hr {\r\n        border: 1px solid #d0cece;\r\n    }\r\n\r\n    .icon {\r\n        width: 30px;\r\n        height: 30px;\r\n    }\r\n\r\n    .unit {\r\n        width: 26px;\r\n        height: 26px;\r\n        color: var(--button);\r\n        background-color: var(--buttonBackground);\r\n        border: none;\r\n        margin-top: 2px;\r\n        cursor: pointer;\r\n        margin-left: 2px;\r\n        font-family: \"atten-round-new\", sans-serif;\r\n        font-weight: 500;\r\n        font-style: normal;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    .unit:disabled {\r\n        background-color: var(--buttonDisabledBackground);\r\n        cursor: not-allowed;\r\n    }\r\n\r\n    .unit:not(:disabled):hover {\r\n        background-color: var(--buttonHoverBackground);\r\n    }\r\n\r\n    .unit:not(:disabled):active {\r\n        color: var(--buttonPressed);\r\n        background-color: var(--buttonPressedBackground);\r\n    }\r\n\r\n    input,\r\n    select {\r\n        outline-style: solid;\r\n        outline-width: 0px;\r\n        outline-color: transparent;\r\n        outline-offset: -1px;\r\n        outline-width: 1px;\r\n        transition: outline-color 0.2s;\r\n        border: transparent;\r\n        padding-left: 5px;\r\n\r\n        &:focus {\r\n            outline-width: 1px;\r\n            outline-color: black;\r\n        }\r\n    }\r\n\r\n    .hasArrows input::-webkit-outer-spin-button,\r\n    .hasArrows input::-webkit-inner-spin-button {\r\n        -webkit-appearance: none;\r\n        margin: 0;\r\n    }\r\n\r\n    .hasArrows input[type=\"number\"] {\r\n        -moz-appearance: textfield;\r\n    }\r\n\r\n    .sliderLine {\r\n        height: var(--spacingHeight);\r\n        display: grid;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: auto 1fr 20px 1fr;\r\n        flex-grow: 1;\r\n\r\n        .label {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n            min-width: 15px;\r\n            font-weight: 600;\r\n        }\r\n\r\n        .img {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .slider {\r\n            grid-column: 4;\r\n            grid-row: 1;\r\n            margin-right: 5px;\r\n            display: flex;\r\n            align-items: center;\r\n            padding-left: 5px;\r\n        }\r\n\r\n        .floatLine {\r\n            grid-column: 2;\r\n            padding-left: 0px;\r\n            grid-template-columns: 1fr auto;\r\n\r\n            .label {\r\n                grid-column: 1;\r\n                display: none;\r\n                align-items: center;\r\n                font-weight: 600;\r\n            }\r\n\r\n            .short {\r\n                grid-column: 1;\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                input {\r\n                    width: 100%;\r\n                    background-color: white;\r\n                    height: 24px;\r\n                }\r\n\r\n                input::-webkit-outer-spin-button,\r\n                input::-webkit-inner-spin-button {\r\n                    -webkit-appearance: none;\r\n                    margin: 0;\r\n                }\r\n\r\n                input[type=\"number\"] {\r\n                    -webkit-appearance: textfield;\r\n                    -moz-appearance: textfield;\r\n                    appearance: textfield;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .ge-divider {\r\n        padding-right: $line-padding-right;\r\n        padding-left: 5px;\r\n        display: grid;\r\n        grid-template-columns: auto 1fr;\r\n        padding-top: 1px;\r\n        padding-bottom: 1px;\r\n    }\r\n    .ge-divider.double {\r\n        display: grid;\r\n        grid-template-columns: auto 1fr 5px 1fr;\r\n        > .textInputLine,\r\n        > .floatLine {\r\n            &:first-of-type {\r\n                grid-column: 2;\r\n            }\r\n            &:nth-of-type(2) {\r\n                grid-column: 4;\r\n            }\r\n        }\r\n    }\r\n    .ge-divider.quad {\r\n        display: grid;\r\n        grid-template-columns: 1fr 5px 1fr 5px 1fr 5px 1fr;\r\n        > .textInputLine,\r\n        > .floatLine {\r\n            &:first-of-type {\r\n                grid-column: 1;\r\n            }\r\n            &:nth-of-type(2) {\r\n                grid-column: 3;\r\n            }\r\n            &:nth-of-type(3) {\r\n                grid-column: 5;\r\n            }\r\n            &:nth-of-type(4) {\r\n                grid-column: 7;\r\n            }\r\n        }\r\n    }\r\n    .ge-grid-divider {\r\n        display: grid;\r\n        grid-template-columns: 150px 1fr auto;\r\n\r\n        .textLine {\r\n            grid-column: auto;\r\n        }\r\n    }\r\n\r\n    .ge-grid-button-divider {\r\n        display: grid;\r\n        grid-template-columns: 60px 60px 60px 60px;\r\n    }\r\n\r\n    .ge-grid-remove {\r\n        display: grid;\r\n        background-color: #c2c2c2;\r\n        margin-bottom: 5px;\r\n        filter: invert(1);\r\n    }\r\n\r\n    .ge-grid-edit {\r\n        display: grid;\r\n        background-color: #878787;\r\n        margin-bottom: 5px;\r\n        filter: invert(1);\r\n    }\r\n\r\n    .ge-grid {\r\n        display: grid;\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    .ge-divider.double .textInputLine {\r\n        grid-template-columns: auto auto 1fr auto;\r\n    }\r\n\r\n    .textInputLine,\r\n    .floatLine {\r\n        user-select: none;\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        height: var(--spacingHeight);\r\n        display: grid;\r\n        grid-template-columns: auto auto 1fr;\r\n        flex-grow: 1;\r\n        .label {\r\n            grid-column: 2;\r\n            display: flex;\r\n            align-items: center;\r\n            min-width: 15px;\r\n            font-weight: 600;\r\n        }\r\n\r\n        .disabled {\r\n            color: var(--backgroundGrey);\r\n            background-color: var(--disabledBackground);\r\n        }\r\n\r\n        img {\r\n            width: 30px;\r\n        }\r\n\r\n        .img {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .value {\r\n            display: flex;\r\n            align-items: center;\r\n            grid-column: 3;\r\n            background: transparent;\r\n            height: 26px;\r\n            position: relative;\r\n            background-color: white;\r\n            margin-top: 2px;\r\n            overflow-y: hidden;\r\n            input {\r\n                width: 100%;\r\n                height: 24px;\r\n                color: #333333;\r\n            }\r\n            input.hasArrows {\r\n                padding-right: 15px;\r\n            }\r\n            .arrows {\r\n                display: none;\r\n                position: absolute;\r\n                right: 0;\r\n                flex-direction: column;\r\n                cursor: grab;\r\n                .downArrowIcon,\r\n                .upArrowIcon {\r\n                    width: 13px;\r\n                    height: 13px;\r\n                }\r\n            }\r\n            &:hover .arrows,\r\n            &:focus .arrows,\r\n            &.dragging .arrows {\r\n                display: flex;\r\n            }\r\n            .arrows:hover {\r\n                background-color: var(--buttonHoverBackground);\r\n            }\r\n            &.dragging .arrows {\r\n                background-color: var(--buttonPressedBackground);\r\n                .downArrowIcon,\r\n                .upArrowIcon {\r\n                    filter: brightness(10);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .textInputLine.withUnits {\r\n        grid-template-columns: auto auto 1fr auto;\r\n    }\r\n\r\n    .textInputArea {\r\n        height: 100%;\r\n        display: grid;\r\n        grid-template-columns: 1fr 120px;\r\n\r\n        .disabled {\r\n            color: var(--backgroundGrey);\r\n            background-color: var(--disabledBackground);\r\n        }\r\n\r\n        .label {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .value {\r\n            display: flex;\r\n            align-items: center;\r\n            grid-column: 2;\r\n\r\n            textarea {\r\n                width: calc(150% - 5px);\r\n                margin-left: -50%;\r\n                height: 40px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .paneContainer {\r\n        margin-top: 3px;\r\n        display: grid;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: 100%;\r\n\r\n        .paneList {\r\n            border-left: 3px solid transparent;\r\n        }\r\n\r\n        &:hover {\r\n            .paneList {\r\n                border-left: 3px solid rgba(51, 122, 183, 0.8);\r\n            }\r\n\r\n            .paneContainer-content {\r\n                .header {\r\n                    .title {\r\n                        border-left: 3px solid rgb(51, 122, 183);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .paneContainer-highlight-border {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            opacity: 1;\r\n            border: 3px solid red;\r\n            transition: opacity 250ms;\r\n            pointer-events: none;\r\n\r\n            &.transparent {\r\n                opacity: 0;\r\n            }\r\n        }\r\n\r\n        .paneContainer-content {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n\r\n            .header {\r\n                display: grid;\r\n                grid-template-columns: 1fr auto;\r\n                background: #cccccc;\r\n                height: var(--spacingHeight);\r\n                padding-bottom: $line-padding-bottom;\r\n                padding-top: $line-padding-top;\r\n                padding-right: 5px;\r\n                cursor: pointer;\r\n\r\n                .title {\r\n                    border-left: 3px solid transparent;\r\n                    padding-left: 5px;\r\n                    grid-column: 1;\r\n                    display: flex;\r\n                    align-items: center;\r\n                }\r\n\r\n                .collapse {\r\n                    grid-column: 2;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    justify-items: center;\r\n                    transform-origin: center;\r\n\r\n                    &.closed {\r\n                        transform: rotate(180deg);\r\n                    }\r\n                }\r\n            }\r\n\r\n            .paneList > div:not(:last-child) {\r\n                border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);\r\n            }\r\n\r\n            .fragment > div:not(:last-child) {\r\n                border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);\r\n            }\r\n        }\r\n    }\r\n\r\n    .color-picker {\r\n        height: 26px;\r\n        width: 26px;\r\n\r\n        .color-rect-background {\r\n            width: calc(100% - 2px);\r\n            height: calc(100% - 2px);\r\n            border: 1px black solid;\r\n            cursor: pointer;\r\n            background: repeating-conic-gradient(#e2e2e2 0% 25%, white 0% 50%) 50% / 100% 100%;\r\n            .color-rect {\r\n                height: 100%;\r\n            }\r\n        }\r\n\r\n        .color-picker-cover {\r\n            z-index: 2;\r\n            position: fixed;\r\n            top: 0px;\r\n            right: 0px;\r\n            bottom: 0px;\r\n            left: 0px;\r\n        }\r\n\r\n        .color-picker-float {\r\n            position: absolute;\r\n            outline: 1px solid black;\r\n        }\r\n\r\n        .color-picker-container {\r\n            background-color: #e2e2e2;\r\n        }\r\n    }\r\n\r\n    .gradient-step {\r\n        display: grid;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: 20px 30px 40px auto 20px 30px;\r\n        padding-top: 5px;\r\n        padding-left: 5px;\r\n        padding-bottom: 5px;\r\n\r\n        .step {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n        }\r\n\r\n        .color {\r\n            grid-row: 1;\r\n            grid-column: 2;\r\n            cursor: pointer;\r\n        }\r\n\r\n        .step-value {\r\n            margin-left: 5px;\r\n            grid-row: 1;\r\n            grid-column: 3;\r\n            text-align: right;\r\n            margin-right: 5px;\r\n        }\r\n\r\n        .step-slider {\r\n            grid-row: 1;\r\n            grid-column: 4;\r\n            display: grid;\r\n            justify-content: stretch;\r\n            align-content: center;\r\n            margin-right: -5px;\r\n            padding-left: 12px;\r\n\r\n            input {\r\n                width: 90%;\r\n            }\r\n        }\r\n\r\n        .gradient-copy {\r\n            grid-row: 1;\r\n            grid-column: 5;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n\r\n            .img {\r\n                height: 20px;\r\n                width: 20px;\r\n            }\r\n            .img:hover {\r\n                cursor: pointer;\r\n            }\r\n        }\r\n        .gradient-delete {\r\n            grid-row: 1;\r\n            grid-column: 6;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n            .img {\r\n                height: 20px;\r\n                width: 20px;\r\n            }\r\n            .img:hover {\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    .alignment-bar {\r\n        display: flex;\r\n        justify-content: center;\r\n        padding-right: 5px;\r\n    }\r\n\r\n    .command-button {\r\n        cursor: pointer;\r\n        width: 30px;\r\n\r\n        .command-label {\r\n            display: none;\r\n        }\r\n\r\n        .command-button-icon {\r\n            height: 100%;\r\n            width: 100%;\r\n            display: grid;\r\n            color: white;\r\n            align-content: center;\r\n            justify-content: center;\r\n        }\r\n\r\n        &:hover {\r\n            background-color: white;\r\n        }\r\n\r\n        .active {\r\n            transform-origin: center;\r\n            background-color: white;\r\n        }\r\n\r\n        img {\r\n            &.active {\r\n                background-color: white;\r\n            }\r\n        }\r\n\r\n        &.disabled {\r\n            background-color: var(--buttonDisabledBackground);\r\n            pointer-events: none;\r\n        }\r\n    }\r\n\r\n    .command-button-alt {\r\n        cursor: pointer;\r\n        width: 40px;\r\n        margin-left: 5px;\r\n        margin-right: 5px;\r\n        .command-label {\r\n            display: none;\r\n        }\r\n\r\n        background-color: white;\r\n        .command-button-icon {\r\n            height: 100%;\r\n            width: 100%;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n        }\r\n        &:hover {\r\n            background-color: #c2c2c2;\r\n            filter: invert(1);\r\n        }\r\n    }\r\n\r\n    .command-button-alt-disabled {\r\n        cursor: pointer;\r\n        pointer-events: none;\r\n        width: 40px;\r\n        margin-left: 5px;\r\n        margin-right: 5px;\r\n        .command-label {\r\n            display: none;\r\n        }\r\n\r\n        background-color: white;\r\n        .command-button-icon {\r\n            height: 100%;\r\n            width: 100%;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n        }\r\n\r\n        img {\r\n            filter: invert(1);\r\n        }\r\n    }\r\n\r\n    .command-button-alt-active {\r\n        cursor: pointer;\r\n        pointer-events: none;\r\n        width: 40px;\r\n        margin-left: 5px;\r\n        margin-right: 5px;\r\n        .command-label {\r\n            display: none;\r\n        }\r\n\r\n        background-color: #c2c2c2;\r\n        filter: invert(1);\r\n        .command-button-icon {\r\n            height: 100%;\r\n            width: 100%;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n        }\r\n    }\r\n\r\n    .floatLine {\r\n        user-select: none;\r\n        height: var(--spacingHeight);\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        display: grid;\r\n        grid-template-columns: auto auto 2fr auto;\r\n        flex-grow: 1;\r\n\r\n        .label {\r\n            grid-column: 2;\r\n            display: flex;\r\n            align-items: center;\r\n            min-width: 15px;\r\n            font-weight: 600;\r\n        }\r\n\r\n        img {\r\n            width: 30px;\r\n        }\r\n\r\n        .img {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .value {\r\n            display: flex;\r\n            align-items: center;\r\n            grid-column: 3;\r\n            background: transparent;\r\n            height: 26px;\r\n            input {\r\n                width: 100%;\r\n                background-color: white;\r\n                height: 24px;\r\n            }\r\n        }\r\n\r\n        .short {\r\n            grid-column: 2;\r\n\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            input {\r\n                width: 100%;\r\n            }\r\n\r\n            input::-webkit-outer-spin-button,\r\n            input::-webkit-inner-spin-button {\r\n                -webkit-appearance: none;\r\n                margin: 0;\r\n            }\r\n\r\n            input[type=\"number\"] {\r\n                -moz-appearance: textfield;\r\n            }\r\n        }\r\n    }\r\n\r\n    .vector3Line {\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        display: grid;\r\n        .firstLine {\r\n            display: grid;\r\n            grid-template-columns: 1fr auto 20px;\r\n            height: var(--spacingHeight);\r\n\r\n            .label {\r\n                grid-column: 1;\r\n                display: flex;\r\n                align-items: center;\r\n            }\r\n\r\n            .vector {\r\n                grid-column: 2;\r\n                display: flex;\r\n                align-items: center;\r\n                text-align: right;\r\n                opacity: 0.8;\r\n            }\r\n\r\n            .expand {\r\n                grid-column: 3;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n\r\n        .secondLine {\r\n            display: grid;\r\n            padding-right: 5px;\r\n            border-left: 1px solid rgb(51, 122, 183);\r\n\r\n            .no-right-margin {\r\n                margin-right: 0;\r\n            }\r\n\r\n            .numeric {\r\n                display: grid;\r\n                grid-template-columns: 1fr auto;\r\n            }\r\n\r\n            .numeric-label {\r\n                text-align: right;\r\n                grid-column: 1;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-self: right;\r\n                margin-right: 10px;\r\n            }\r\n\r\n            .numeric-value {\r\n                width: 120px;\r\n                grid-column: 2;\r\n                display: flex;\r\n                align-items: center;\r\n                border: 1px solid rgb(51, 122, 183);\r\n            }\r\n        }\r\n    }\r\n\r\n    .buttonLine {\r\n        height: var(--spacingHeight);\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        display: grid;\r\n        align-items: center;\r\n        justify-items: stretch;\r\n        padding-bottom: 5px;\r\n        input[type=\"file\"] {\r\n            display: none;\r\n        }\r\n\r\n        .file-upload {\r\n            background: var(--backgroundGrey);\r\n            border: 1px solid #424242;\r\n            margin: 5px 10px;\r\n            color: white;\r\n            padding: 4px 5px;\r\n            opacity: 0.9;\r\n            cursor: pointer;\r\n            text-align: center;\r\n            border-radius: 4px;\r\n        }\r\n\r\n        .file-upload:hover {\r\n            opacity: 1;\r\n        }\r\n\r\n        .file-upload:active {\r\n            transform: scale(0.98);\r\n            transform-origin: 0.5 0.5;\r\n        }\r\n\r\n        button {\r\n            background: var(--backgroundGrey);\r\n            border: 1px solid #424242;\r\n            margin: 5px 10px 5px 10px;\r\n            color: white;\r\n            padding: 4px 5px;\r\n            opacity: 0.9;\r\n            border-radius: 4px;\r\n        }\r\n\r\n        button:hover {\r\n            opacity: 1;\r\n        }\r\n\r\n        button:active {\r\n            background: #282828;\r\n        }\r\n\r\n        button:focus {\r\n            border: 1px solid #424242;\r\n            outline: 0px;\r\n        }\r\n    }\r\n\r\n    .numeric {\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        height: var(--spacingHeight);\r\n        display: grid;\r\n        grid-template-columns: 1fr 120px auto;\r\n\r\n        .numeric-label {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .number {\r\n            display: flex;\r\n            align-items: center;\r\n            grid-column: 2;\r\n            height: 10px;\r\n            .input {\r\n                width: calc(100% - 5px);\r\n                height: 10px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .checkBoxLine {\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        height: var(--spacingHeight);\r\n        display: grid;\r\n        grid-template-columns: auto 1fr auto;\r\n        flex-grow: 1;\r\n\r\n        .label {\r\n            grid-column: 2;\r\n            display: flex;\r\n            align-items: center;\r\n            min-width: 100px;\r\n            margin-left: 15px;\r\n            height: var(--spacingHeight);\r\n            font-weight: 600;\r\n        }\r\n\r\n        img {\r\n            width: 30px;\r\n        }\r\n\r\n        .img {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .hidden {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .listLine {\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        height: var(--spacingHeight);\r\n        display: grid;\r\n        grid-template-columns: auto 1fr auto;\r\n        flex-grow: 1;\r\n\r\n        .label {\r\n            grid-column: 2;\r\n            display: none;\r\n            align-items: center;\r\n        }\r\n\r\n        img {\r\n            width: 30px;\r\n        }\r\n\r\n        .img {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .options {\r\n            grid-column: 2;\r\n            padding-left: 15px;\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            select {\r\n                width: 100%;\r\n                height: 25px;\r\n                border: transparent;\r\n            }\r\n\r\n            input {\r\n                width: 100%;\r\n                height: 24px;\r\n                color: #333333;\r\n            }\r\n        }\r\n    }\r\n\r\n    .color3Line {\r\n        padding-left: 15px;\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        display: grid;\r\n        flex-grow: 1;\r\n\r\n        .firstLine {\r\n            height: var(--spacingHeight);\r\n            display: flex;\r\n            align-items: center;\r\n\r\n            .label {\r\n                grid-column: 2;\r\n                padding-left: 5px;\r\n                display: none;\r\n                align-items: center;\r\n                min-width: 15px;\r\n            }\r\n\r\n            .img {\r\n                grid-column: 1;\r\n                display: flex;\r\n                align-items: center;\r\n            }\r\n\r\n            img {\r\n                width: 30px;\r\n                height: 30px;\r\n            }\r\n\r\n            .textInputLine {\r\n                grid-column: 3;\r\n                padding-left: 2px;\r\n                flex-grow: 1;\r\n            }\r\n\r\n            .color3 {\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                input {\r\n                    margin-right: 5px;\r\n                }\r\n            }\r\n\r\n            .copy {\r\n                grid-column: 4;\r\n                display: none;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n                color: black;\r\n                img {\r\n                    height: 100%;\r\n                    width: 20px;\r\n                }\r\n            }\r\n\r\n            .expand {\r\n                grid-column: 4;\r\n                display: none;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n\r\n                img {\r\n                    height: 100%;\r\n                    width: 20px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .secondLine {\r\n            display: grid;\r\n            padding-right: 5px;\r\n            border-left: 1px solid rgb(51, 122, 183);\r\n\r\n            .numeric {\r\n                display: grid;\r\n                grid-template-columns: 1fr auto;\r\n            }\r\n\r\n            .numeric-label {\r\n                text-align: right;\r\n                grid-column: 1;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-self: right;\r\n                margin-right: 10px;\r\n            }\r\n\r\n            .numeric-value {\r\n                width: 120px;\r\n                grid-column: 2;\r\n                display: flex;\r\n                align-items: center;\r\n                border: 1px solid rgb(51, 122, 183);\r\n            }\r\n        }\r\n    }\r\n\r\n    .textLine {\r\n        padding-left: $line-padding-left;\r\n        padding-bottom: $line-padding-bottom;\r\n        padding-top: $line-padding-top;\r\n        padding-right: $line-padding-right;\r\n        height: auto;\r\n        display: grid;\r\n        grid-template-columns: auto auto 2fr 1fr;\r\n        .label {\r\n            grid-column: 2;\r\n            padding-left: 5px;\r\n            padding-top: 4px;\r\n            display: flex;\r\n            align-items: left;\r\n            min-width: 15px;\r\n            color: #a9a9a9;\r\n            font-size: 10px;\r\n            font-family: \"acumin-pro-semi-condensed\", sans-serif;\r\n            font-weight: 600;\r\n        }\r\n\r\n        img {\r\n            width: 30px;\r\n        }\r\n\r\n        .img {\r\n            grid-column: 1;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        .link-value {\r\n            grid-column: 2;\r\n            white-space: nowrap;\r\n            text-overflow: ellipsis;\r\n            overflow: hidden;\r\n            text-align: end;\r\n            opacity: 0.8;\r\n            margin: 5px;\r\n            margin-top: 6px;\r\n            max-width: 140px;\r\n            text-decoration: underline;\r\n            cursor: pointer;\r\n        }\r\n\r\n        .value {\r\n            display: none;\r\n            grid-column: 3;\r\n            white-space: nowrap;\r\n            text-overflow: ellipsis;\r\n            overflow: hidden;\r\n            text-align: end;\r\n            opacity: 0.8;\r\n            margin: 5px;\r\n            margin-top: 6px;\r\n            max-width: 200px;\r\n            -webkit-user-select: text;\r\n            -moz-user-select: text;\r\n            -ms-user-select: text;\r\n            user-select: text;\r\n\r\n            &.check {\r\n                color: green;\r\n            }\r\n\r\n            &.uncheck {\r\n                color: red;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
